import { useEffect, useState } from 'react'
import type { MenuItem } from '@/components/maia/types'
import { getStoredMenuOrFallback } from '@/lib/weeklyDishes'

export interface WeeklyMenu {
  primis: MenuItem[]
  seconds: MenuItem[]
}

export function useWeeklyMenu(fallback: WeeklyMenu): WeeklyMenu {
  const [menu, setMenu] = useState<WeeklyMenu>(fallback)

  useEffect(() => {
    setMenu(getStoredMenuOrFallback(fallback))
  }, [fallback])

  return menu
}
